angular.module('bmsApp.settings').factory('UserPermissionSvc', function ($http, $log, $window, $q, CRUDSvc) {

	return {
		index: function(params){return CRUDSvc.get('api/permission/index', params);},
		create: function (data) {return CRUDSvc.create('api/permission/create', data);},
		update: function (data) {return CRUDSvc.update('api/permission/update', data);},
		delete: function(params) {return CRUDSvc.delete('api/permission/delete', params);}
	}

});



